import React from 'react';
import { connect } from 'react-redux';
import Page from '../../components/page/page';
import bindAll from "lodash.bindall";
import qs from "qs";
import { setUser } from '../../reducers/teach';
import { me } from '../../api/user';
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import styles from './vip.css';
import QRcode from 'qrcode.react';
import moment from 'moment';
import { createOrder, orderStatus, inquiryCode } from '../../api/order';
import vipImg from "../../components/pay-modal/vip.png";
import gou from "../../components/pay-modal/gou.png";
import wxpay from "../../components/pay-modal/wxpay.png";
import phone from "../../components/pay-modal/phone.png";
import message from '../../components/message/message.jsx';


let timer = null
class VipPage extends React.PureComponent {

    constructor(props) {
        super(props);
        bindAll(this, [
            'createOrders',
            'getOrderStatus',
            'closeOrder',
            'editCode',
            'verifyCode',
            'getUser'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        this.state = {
            goodsInfo: {},
            payStatus: false,
            payNum: 0,
            discountCode: null,
            vipPrice: 0
        }
    }

    componentDidMount() {
        this.createOrders()
        this.getUser();
        if (this.query.code) {
            this.setState({
                discountCode: this.query.code
            }, () => {
                this.verifyCode();
            })
        }
    }

    getUser() {
        me({}, { quiet: !!this.props.username }).then(res => {
            this.props.setUser(res)
        });
    }

    createOrders() {
        const { payNum } = this.state
        createOrder({
            goods_id: 1,
            code:this.query.code
        }, { quiet: true }).then((res) => {
            if (res) {
                this.setState({ goodsInfo: res, vipPrice: res.pay_amt });
                if (payNum !== 3) {
                    this.getOrderStatus(res.id);
                }
            }
        })
    }

    getOrderStatus(id) {
        orderStatus({
            id: id
        }, { quiet: true }).then((res) => {
            if (res) {
                if (res.payment_status === 0) {
                    this.setState({ payStatus: false })
                }
                if (res.payment_status === 1) {
                    this.setState({ payStatus: true })
                } else if (res.payment_status === 3) {
                    this.setState({ payNum: 3 }).then(() => { setTimeout(() => { this.setState({ payStatus: false }) }, 2000) })
                    clearTimeout(timer)
                } else if (res.payment_status === 4) {
                    this.setState({ payNum: 4 })
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    this.getOrderStatus(id);
                }, 3000)
            }
        })
    }

    closeOrder() {
        const { onClose, onReload } = this.props
        onClose();
        clearTimeout(timer);
        onReload();
    }

    editCode(e) {
        this.setState({
            discountCode: e.target.value
        })
    }

    async verifyCode() {
        const { discountCode } = this.state;
        if(!discountCode){
            message.show("请输入渠道码")
            return
        }
        try {
            let vip = await inquiryCode({
                code: discountCode,
            },{quiet: true});
            this.setState({
                vipPrice: vip.price
            })
            clearTimeout(timer);
        } catch (error) {
            message.show(error.message);
        }
    }

    render() {
        const { user } = this.props;
        const { goodsInfo, payStatus, payNum, discountCode, vipPrice } = this.state;
        const isVip = user.vip ? user.vip > moment().format("YYYY-MM-DD HH:mm:ss") ? true : false : false;
        const url = `https://www.xiaoaoai.com/h5/pay/index.html?id=${goodsInfo.no && goodsInfo.no}&title=${encodeURIComponent(goodsInfo.goods_title && goodsInfo.goods_title)}&pay=${vipPrice}&name=${encodeURIComponent(user && user.name)}`;

        return (
            <Page isModal={true} title={"会员"}>
                <PageContentMargin>
                    {payStatus ? (
                        <div className={styles.boxs}>
                            {/* <div className={styles.closeBtn} style={{float: 'right'}} onClick={() => this.closeOrder()}>X</div> */}
                            <div className={styles.paying}><img src={phone}></img></div>
                            <div className={styles.payTips}>{payNum === 3 ? '支付成功' : '请在手机上完成支付'}</div>
                            {payNum !== 3 ? (
                                // <div className={styles.payBtn}><button onClick={() => this.closeOrder()}>已完成支付</button></div>
                                <span className={styles.loading}></span>
                            ) : (null)}
                        </div>
                    ) : (
                        <div className={styles.boxs}>
                            <div className={styles.title}>
                                <div className={styles.userContent}>
                                    <img className={isVip ? styles.isVip : null} src={window.config.staticURL + '/avatar/' + (user.avatar || 'default.png')}></img>
                                    <div>
                                        {
                                            isVip ? (
                                                <span className={isVip ? styles.isVip : null}>{user.name}<img src={vipImg}></img></span>
                                            ) : (
                                                <span>{user.name}</span>
                                            )
                                        }
                                        <p>{isVip ? `您已是VIP会员，会员身份将于${user.vip}过期` : `您还不是VIP会员`}</p>
                                    </div>
                                </div>
                                {/* <span className={styles.closeBtn} onClick={() => this.closeOrder()}>X</span> */}
                            </div>

                            <div className={styles.vipContent}>
                                <span>{goodsInfo.goods_title}</span>
                                <div className={styles.money}><span>￥</span>{vipPrice}</div>
                                <p><img src={gou} />{isVip ? '续费会员' : '开通会员'}</p>
                            </div>

                            <div className={styles.discountBox}>
                                <span>渠道优惠码</span>
                                <input defaultValue={discountCode} onChange={e => this.editCode(e)}></input>
                                <button onClick={() => this.verifyCode()}>验证</button>
                            </div>

                            <div className={styles.payContent}>
                                <div className={styles.qrcode}>
                                    <QRcode value={url}></QRcode>
                                    {/* <QRcode value={`https://dev.scratch-edu.com/h5/pay/index.html`}></QRcode> */}
                                </div>
                                <div className={styles.payWay}>
                                    <span>扫码支付</span>
                                    <p><img src={wxpay} />微信支付</p>
                                    <div className={styles.money}><span>￥</span>{vipPrice}</div>
                                </div>
                            </div>

                        </div>
                    )
                    }
                </PageContentMargin>
            </Page>
        );
    }
}


const mapStateToProps = state => ({
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setUser: res => dispatch(setUser(res))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VipPage);
